
function reviver(key: any, value: any): any {
    if (typeof value === 'string') {
        var regExResult = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+\-])(\d{2}):(\d{2}))$/.exec(value);
        if (regExResult) {
            //return new Date(+regExResult[1], +regExResult[2] - 1, +regExResult[3], +regExResult[4], +regExResult[5], +regExResult[6]);
            return new Date(Date.UTC(+regExResult[1], +regExResult[2] - 1, +regExResult[3], +regExResult[4], +regExResult[5], +regExResult[6]));
        }
    }
    return value;
}


export interface IStorage<T> {
    save(): void;
    set(value: T | null): void;
    get(): T | null;
}
export interface IStorageAsync<T> {
    save(): void;
    set(value: T | null): void;
    getAsync(): Promise<T | null>;
}

export class InMemoryStorage<T> implements IStorage<T> {
    private _value: T | null = null;
    save() { }
    get(): T | null {
        return this._value;
    }
    set(obj: T) {
        this._value = obj;
    }
}
export class InStorage<T> implements IStorage<T>, IStorageAsync<T> {
    private _value: T | null = null;

    private _date!: Date;

    constructor(private _storage: Storage, private _key: string, private _minutes: number = 60) {
    }

    save() {
        this._date = new Date();

        this._storage.setItem(this._key, JSON.stringify({ date: this._date, obj: this._value }));
    }

    get(): T | null {
        if (!this._value) {
            var json = this._storage.getItem(this._key);
            if (json) {
                var withDate = JSON.parse(json, reviver);
                this._date = withDate.date;
                if (this._date.valueOf() + (this._minutes * 60000) < new Date().valueOf()) {
                    //@ts-ignore
                    delete this._date;
                    this._value = null;
                }
                else
                    this._value = withDate.obj;
            }
            else {
                this._value = null;
            }
        }
        return this._value;
    }

    async getAsync(): Promise<T | null> {
        return this.get();
    }

    set(obj: T | null) {
        this._value = obj;
        this._date = new Date();
        this._storage.setItem(this._key, JSON.stringify({ date: this._date, obj: obj }));
    }
}

export interface StorageAsync {
    /**
     * Fetches key and passes the result to callback, along with an Error if there is any.
     */
    getItem(key: string, callback?: (error?: Error, result?: string) => void): Promise<string | null>;

    /**
     * Sets value for key and calls callback on completion, along with an Error if there is any
     */
    setItem(key: string, value: string, callback?: (error?: Error) => void): Promise<void>;

    removeItem(key: string, callback?: (error?: Error) => void): Promise<void>;

    /**
     * Merges existing value with input value, assuming they are stringified json. Returns a Promise object.
     * Not supported by all native implementation
     */
    mergeItem(key: string, value: string, callback?: (error?: Error) => void): Promise<void>;

    /**
     * Erases all AsyncStorage for all clients, libraries, etc. You probably don't want to call this.
     * Use removeItem or multiRemove to clear only your own keys instead.
     */
    clear(callback?: (error?: Error) => void): Promise<void>;

    /**
     * Gets all keys known to the app, for all callers, libraries, etc
     */
    getAllKeys(callback?: (error?: Error, keys?: string[]) => void): Promise<string[]>;

    /**
     * multiGet invokes callback with an array of key-value pair arrays that matches the input format of multiSet
     */
    multiGet(
        keys: string[],
        callback?: (errors?: Error[], result?: [string, string][]) => void
    ): Promise<[string, string][]>;

    /**
     * multiSet and multiMerge take arrays of key-value array pairs that match the output of multiGet,
     *
     * multiSet([['k1', 'val1'], ['k2', 'val2']], cb);
     */
    multiSet(keyValuePairs: string[][], callback?: (errors?: Error[]) => void): Promise<void>;

    /**
     * Delete all the keys in the keys array.
     */
    multiRemove(keys: string[], callback?: (errors?: Error[]) => void): Promise<void>;

    /**
     * Merges existing values with input values, assuming they are stringified json.
     * Returns a Promise object.
     *
     * Not supported by all native implementations.
     */
    multiMerge(keyValuePairs: string[][], callback?: (errors?: Error[]) => void): Promise<void>;
}

export class InStorageAsync<T> implements IStorageAsync<T> {
    private _value: T | null = null;

    private _date!: Date;

    constructor(private _storage: StorageAsync, private _key: string, private _minutes: number = 60) {
    }

    async save() {
        this._date = new Date();

        await this._storage.setItem(this._key, JSON.stringify({ date: this._date, obj: this._value }));
    }
    async getAsync(): Promise<T | null> {
        if (!this._value) {
            var json = await this._storage.getItem(this._key);
            if (json) {
                var withDate = JSON.parse(json, reviver);
                this._date = withDate.date;
                if (this._date.valueOf() + (this._minutes * 60000) < new Date().valueOf()) {
                    //@ts-ignore
                    delete this._date;
                    this._value = null;
                }
                else
                    this._value = withDate.obj;
            }
            else {
                this._value = null;
            }
        }
        return this._value;
    }
    async set(obj: T | null) {
        this._value = obj;
        this._date = new Date();
        await this._storage.setItem(this._key, JSON.stringify({ date: this._date, obj: obj }));
    }
}
